import $http from '../../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Método para obtener las opciones del formulario.
 *
 * @param {*} param0
 */
export async function getOpciones({commit, state}) {
  commit('dashboard/load', true, {root: true});
  await $http.get('controles/5', state.ingreso)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('cargarOpciones', response.data);
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });

}

/**
 * Método que guarda la clasificación HMIS del producto químico.
 *
 * @param {*} param0
 */
export async function guardaHmis({commit, state, rootState}) {

  let id_producto = rootState.productos.selectedProduct.id;

  if (!id_producto) {
    id_producto = rootState.productos.selectedProduct.Idproducto;
  }

  commit('dashboard/load', true, {root: true});

  await $http.post(`adm_productos/hmis/crear/${id_producto}`, state.selectedHmis)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Muy bien!',
        text: response.data.message,
        showConfirmButton: false,
        timer: 3000
      });
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error',
        text: error.message + '<br> ' + error.errors,
        showConfirmButton: true,
        timer: 5000
      });
    });
}

/**
 * Método para obtener la clasificación HMIS del producto químico.
 *
 * @param {*} param0
 */
export async function getHmis({commit, state, rootState}) {

  var producto = rootState.productos.selectedProduct.id;
  if (producto == '') {
    producto = rootState.productos.selectedProduct.Idproducto;
  }
  commit('dashboard/load', true, {root: true});
  commit('resetHmis');

  var IdProducto = parseInt(producto);
  await $http.get(`adm_productos/hmis/ver/${IdProducto}`, state.selectedHmis)
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setHmis', response.data.data);

    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}
